import { agentsHomeEntryPoint } from '@jira/project-settings__agents-home/src/agentsHome.entrypoint.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdSpaceAgents } from '@jira/navigation-apps__constants/src/SidebarIdSpaceAgents.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { licenseDetailsResource_DEPRECATED_DO_NOT_USE } from '@jira/router-resources__business-license-details/src/useIsPremiumUserSeat.tsx';
import { coreProjectLayout } from '@jira/platform__layouts-core-project-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectSettingsCoreAgentsRoute } from '@jira/router-routes__project-settings-core-routes/src/projectSettingsCoreAgentsRoute.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getNavigationSidebarProjectSettingsResource } from './common/getNavigationSidebarProjectSettingsResource.tsx';
import type { Route } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: agentsHomeEntryPoint,
});

export const projectSettingsCoreAgentsRouteEntry: Route = createEntry(
	projectSettingsCoreAgentsRoute,
	() => ({
		group: 'project-settings-core',
		ufoName: 'project-settings.agents.jwm',

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdSpaceAgents,
		},

		layout: coreProjectLayout,

		entryPoint: () =>
			expVal('yamato-agents-home-space-settings-beta', 'isEnabled', false)
				? pageEntryPoint
				: notFoundPageEntrypoint,

		resources: [
			...getNavigationResources(),
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			...getNavigationSidebarProjectSettingsResource(),
			...getBusinessProjectResources(),
			licenseDetailsResource_DEPRECATED_DO_NOT_USE,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},

		meta: {
			reporting: {
				packageName: 'jiraProjectSettingsAgentsHome',
				id: 'project-settings.agents.jwm',
				teamName: 'Yurree',
			},
		},
	}),
);
